"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _layout = require("@berlitz/globals/lib/components/layout");
var _typography = require("@berlitz/globals/lib/components/typography");
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _style = require("./style");
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isExternalLink = _interopRequireDefault(require("@berlitz/max-utils/lib/isExternalLink"));
var _icons = _interopRequireDefault(require("../icons"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var slickSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  infinite: true,
  speed: 300,
  initialSlide: 0
};
var BlockIconGrid = function BlockIconGrid(_ref) {
  var disablePaddingBottom = _ref.disablePaddingBottom,
    disablePaddingTop = _ref.disablePaddingTop,
    gridItems = _ref.gridItems,
    iconColor = _ref.iconColor,
    largeIcons = _ref.largeIcons,
    light = _ref.light,
    mobileCarousel = _ref.mobileCarousel,
    size = _ref.size,
    subtitle = _ref.subtitle,
    title = _ref.title;
  var componentHasSlider = gridItems.length > 3 && mobileCarousel;
  var lgGridSize = (0, _react.useMemo)(function () {
    return gridItems.length % 3 === 0 || gridItems.length % 5 === 0 ? 4 : 6;
  }, [gridItems]);
  var GridItem = function GridItem(_ref2) {
    var item = _ref2.item,
      index = _ref2.index;
    var hasLink = (0, _get.default)(item, 'link');
    var isExternal = (0, _isExternalLink.default)(hasLink);
    return /*#__PURE__*/_react.default.createElement(_style.Link, {
      as: hasLink ? 'a' : 'div',
      href: hasLink && item.link,
      target: isExternal ? '_blank' : '_self',
      rel: isExternal ? 'noopener noreferrer' : null,
      "data-key": "icon-grid__link-".concat(index)
    }, /*#__PURE__*/_react.default.createElement(_style.Icon, {
      "data-key": "icon-grid__icon-".concat(index)
    }, (0, _icons.default)(item.iconName, !light ? iconColor : 'brand01', "icon-".concat(index), largeIcons ? 'xl' : 'lg')), item.title && /*#__PURE__*/_react.default.createElement(_style.Title, {
      inverse: !light,
      "data-key": "icon-grid__title-".concat(index),
      link: item.link,
      dangerouslySetInnerHTML: {
        __html: item.title
      }
    }), item.link && /*#__PURE__*/_react.default.createElement(_spacer.default, {
      size: "md"
    }), item.subtitle && /*#__PURE__*/_react.default.createElement(_style.SubText, {
      inverse: !light,
      "data-key": "icon-grid__subtitle-".concat(index),
      dangerouslySetInnerHTML: {
        __html: item.subtitle
      }
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_layout.Section, {
    backgroundColor: !light ? 'ui05' : 'ui00',
    disablePaddingBottom: disablePaddingBottom,
    disablePaddingTop: disablePaddingTop,
    size: size
  }, /*#__PURE__*/_react.default.createElement(_typography.TextAlign, {
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_layout.Grid, null, (title || subtitle) && /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, {
    center: "lg"
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Col, {
    xs: 12,
    lg: 9
  }, title && /*#__PURE__*/_react.default.createElement(_typography.H2, {
    disableMargin: !subtitle,
    inverse: !light,
    "data-key": "icon-grid__title",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), subtitle && /*#__PURE__*/_react.default.createElement(_typography.P, {
    inverse: !light,
    "data-key": "icon-grid__subtext",
    disableMargin: true,
    dangerouslySetInnerHTML: {
      __html: subtitle
    }
  }), /*#__PURE__*/_react.default.createElement(_spacer.default, {
    size: "md",
    breakpoints: {
      lg: 'sm'
    }
  }))), /*#__PURE__*/_react.default.createElement(_style.DesktopGrid, {
    componentHasSlider: componentHasSlider
  }, /*#__PURE__*/_react.default.createElement(_reactStyledFlexboxgrid.Row, null, gridItems.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_style.Slide, {
      lg: lgGridSize,
      key: index
    }, /*#__PURE__*/_react.default.createElement(GridItem, {
      item: item,
      index: index
    }));
  }))), componentHasSlider && /*#__PURE__*/_react.default.createElement(_style.MobileSlider, null, /*#__PURE__*/_react.default.createElement(_style.StyledSlider, _extends({}, slickSettings, {
    light: light
  }), gridItems.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_style.Slide, {
      lg: lgGridSize,
      key: index
    }, /*#__PURE__*/_react.default.createElement(GridItem, {
      item: item,
      index: index
    }));
  }))))));
};
BlockIconGrid.defaultProps = {
  gridItems: [],
  iconColor: 'brand06',
  light: false,
  mobileCarousel: false,
  size: 'lg'
};
var _default = BlockIconGrid;
exports.default = _default;